<template>
  <div class="flex-grow mx-auto container p-8 text-2xl">
    <HomeHeaderContent header="Startsida" />
    <CustomShape />
    <HomeBlocks />
  </div>
</template>

<script>
// @ is an alias to /src
import HomeHeaderContent from '@/components/HomeHeaderContent.vue'
import HomeBlocks from '@/components/HomeBlocks.vue'
import CustomShape from '@/components/CustomShape.vue'

export default {
  name: 'HomeView',
  components: {
    HomeHeaderContent,
    HomeBlocks,
    CustomShape
  }
}
</script>
